<template>
    <div>
        <el-form-item label="编号" v-show="false">
            <el-input v-model="id"></el-input>
        </el-form-item>
        <el-form-item label="名称">
            <el-input v-model="name"></el-input>
        </el-form-item>

        <el-form-item label="类型" v-show="needConditiona">
            <el-select v-model="defaultflow" @change="changeFlow" >
                <el-option label="请选择" value=""></el-option>
                <el-option label="通过" :value="true"></el-option>
                <el-option label="拒绝" :value="false"></el-option>
            </el-select>
        </el-form-item>


    </div>
</template>
<script>
import bpmnHelper from './js/helper/BpmnHelper';
import {is} from 'bpmn-js/lib/util/ModelUtil';
import AdjacencyMatrixGraph from './js/util/AdjacencyMatrixGraph';
import {OperatorAllOptions,LogicOptions,wfResult,OperatorLessOptions} from '@/api/static';
import {isBlank} from './js/util/CommonUtils';
import AdapterComponent from './assistComponents/AdapterComponent.vue';

const eventDefinitionHelper = require('./js/helper/EventDefinitionHelper'),
      isAny = require('bpmn-js/lib/features/modeling/util/ModelingUtil').isAny,
      elementHelper = require('./js/helper/ElementHelper'),
      forEach = require('lodash/forEach'),
      filter = require('lodash/filter'),
      find = require('lodash/find'),
      findIndex = require('lodash/findIndex'),
      includes = require('lodash/includes'),
      replace = require('lodash/replace'),
      map = require('lodash/map'),
      uuid = require('uuid/v1');
const DEFAULT_VALUE = {
    condition:'未配置任何条件',
    logicLabel:'无'
}
export default {
    props:['element'],
    inject: ['bpmnModeler'],
    components:{AdapterComponent},
    data(){
        return {
            modeling: null,
            id : this.element.id || '',
            name: '',
            condition:DEFAULT_VALUE.condition,
            defaultflow:'',
            //时都需要条件
            needConditiona:false,
            dialogTableVisible:false,
            //条件列表
            conditionList:[],
            logicOptions: LogicOptions,
            conditionalOpts:[{VALUE:'>',TEXT:'大于'},{VALUE:'>=',TEXT:'大于等于'},{VALUE:'==',TEXT:'等于'},{VALUE:'<',TEXT:'小于'},{VALUE:'<=',TEXT:'小于等于'}],
            formShow:false,
            form:{
                id:'',
                variable:'',
                conditionalOpt:'',
                conditionalVal:'',
                logic:'',
                tmp:{
                    //变量的详细信息
                    variableInfo:undefined,
                    componentType:'input',
                    conditionalValData:undefined
                }
            },
            table:{
                conditions: [],
                selectedRow:undefined
            },
            dataList:[
                {VALUE:0,TEXT:"否"},
                {VALUE:1,TEXT:"是"}
            ]

        }
    },

    mounted(){
        const bpmnModeler = this.bpmnModeler();
        this.modeling = bpmnModeler.get("modeling");
        this.VariablesUrl()
    },

    methods:{
        // 获取变量
        VariablesUrl(){
            if(this.$route.query.busProcessVariablesUrl){
                let data = {}
                let url = 'usercenter'+this.$route.query.busProcessVariablesUrl;
                this.reqGet(url,'',(result)=>{
                    // console.log(result)
                    result.forEach(item=>{
                        data.VALUE = item.fieldName;
                        data.TEXT = item.title;
                        this.conditionList.push(data);
                        data = {};
                    })

                })
            }

            this.conditionList.push({VALUE:"agree",TEXT:"是否同意"})
        },
        changeFlow(){
            const bpmnModeler = this.bpmnModeler();
            // 先清空
            const moddle = bpmnModeler.get('moddle');
            const bpmnFactory = bpmnModeler.get('bpmnFactory');

            if(this.defaultflow === ''){
                this.modeling.updateProperties(this.element, { conditionExpression: undefined });
            }else{
                let conditionalEventDefinition = eventDefinitionHelper.getConditionalEventDefinition(this.element);
                //生成表达式
                let conditionExpress = '${isPass == ' + this.defaultflow + '}';
                //设置表达式
                let expression = moddle.create('bpmn:FormalExpression',{body:conditionExpress});
                this.modeling.updateProperties(this.element, { conditionExpression: expression });
            }
        },
        openDialog(){
            this.table.conditions = [];
            this.table.selectedRow = undefined;
            this.form.tmp.componentType = 'input';
            //加载可配置的条件列表
            this.loadCanditionList();
            this.loadCondition();
            //翻译
            this.translateAllConditions();
            this.dialogTableVisible = true;
        },
        closeDialog(){
            let bo = bpmnHelper.getBo(this.element);
            this.loadCondition(bo);
        },
        selectRow(row, column, event){
            this.table.selectedRow = row;
            console.log(row)
        },
        addRow(){
            this.table.conditions.push({
                id:uuid(),
                variable:'',
                variableLabel:'',
                conditionalOpt:'',
                conditionalOptLabel:'',
                conditionalVal:'',
                conditionalValLabel:'',
                logic:'',
                logicLabel:''
            });
        },
        //保存条件
        saveConditions(){
            let conditions = this.table.conditions;
            console.log(this.table.conditions,"保存")
            let conditionExpress = '';
            let conditionList = this.conditionList;
            if(validateConditions(conditions)){
                forEach(conditions,function(condition,index){
                    let conditionInfo = find(conditionList,{VALUE:condition.variable});
                    if(conditionInfo){
                         let conditionalVal;
                         if(conditionInfo.type != 'number'){
                            conditionalVal = '"'+condition.conditionalVal+'"';
                         }
                         if(index == conditions.length-1 || conditions.length == 1){
                            conditionExpress += condition.variable+condition.conditionalOpt+conditionalVal;
                         }else{
                            conditionExpress += condition.variable+condition.conditionalOpt+conditionalVal+' '+condition.logic+' ';
                         }
                    }
                });
                let conditionOrConditionExpression = undefined;
                let bo = bpmnHelper.getBo(this.element);
                const bpmnModeler = this.bpmnModeler();
                const commandStack = bpmnModeler.get('commandStack');
                if(conditionExpress.length > 0){

                    let source = this.element.source;
                    // 如果是默认条线，移除source的属性
                    // if (source && source.businessObject.defaultflow) {
                    //     bpmnHelper.updatePropertiesByCmd(source,commandStack,{ 'defaultflow': false });
                    // }
                }
                bpmnHelper.updatePropertiesByCmd(this.element,commandStack,{conditionExpression: conditionOrConditionExpression});
                this.dialogTableVisible = false;
            };

        },
        removeRow(){
            if(this.table.selectedRow !== undefined){
                //删除选定的数组
                let index = findIndex(this.table.conditions,{id:this.table.selectedRow.id});
                this.table.conditions.splice(index,1);
                this.table.selectedRow = undefined;
            }
        },
        loadCondition(bo){
            bo = bo || bpmnHelper.getBo(this.element);
            let conditionalEventDefinition = eventDefinitionHelper.getConditionalEventDefinition(this.element);
            let conditionExpression = conditionalEventDefinition? conditionalEventDefinition.condition:bo.conditionExpression;
            

            /***
            this.condition ='未配置任何条件';
            if(conditionExpression){
                //获取配置的条件表达
                let condition = conditionExpression.get('body');
                this.parseCondition(condition);
            }
            ****/
        },
        parseCondition(conditionExpress){
            let operators = ['!','=','>','<'];
            let logicOperators = ['&','|'];
            conditionExpress = conditionExpress.replace('$','').replace('{','').replace('}','').replace(new RegExp('"','g'),'');
            this.table.conditions = [];
            let self = this;
            splitConditionExpress(conditionExpress);
            //截取表达时候
            function splitConditionExpress(str){
                //正查找查找操作符
                let idx = findChar(str,true,true,logicOperators);
                if(idx == -1){
                    let row = createConditionRow(str);
                    self.table.conditions.push(row);
                    return;
                }else{
                    //操作符
                    let logic = str.substring(idx,idx+2);
                    let conditionExpress = str.substring(0,idx);
                    let row = createConditionRow(conditionExpress,logic);
                    self.table.conditions.push(row);
                    let newStr = str.substring(idx+2);
                    splitConditionExpress(newStr);
                }
            }
            function createConditionRow(conditionExpress,logic){
                let row  = {};
                //纯表达式
                let headOptIdx = findChar(conditionExpress,true,false,operators);
                let footOptIdx = findChar(conditionExpress,false,false,operators);
                //变量
                let variable = conditionExpress.substring(0,headOptIdx).trim();
                //值
                let val = conditionExpress.substring(footOptIdx+1,conditionExpress.length).trim();
                //操作符
                let opt =  conditionExpress.substring(headOptIdx,footOptIdx+1).trim();
                row.id = uuid();
                row.variable = variable;
                row.conditionalOpt = opt;
                row.conditionalVal = val;
                row.logic = logic
                return row;
            }
            /**
             * @description 检索第一个的操作操作符
             * @param str 需要被检索的字符串
             * @param  type 类型 true:正查找 false:反查找
             * @param report 检索的字符是否需要重复 true | false
             */
            function findChar(str,type,report,operators){
                let index = -1;
                let len = str.length;
                if(type){
                    for(let i = 0;i < len; i++){
                        let char = str.charAt(i);
                        if(includes(operators,char)){
                            //查找第一个
                            if(report){
                                if(char == str.charAt(i+1)){
                                    index = i;
                                    break;
                                }
                            }else{
                                index = i;
                                break;
                            }
                        }
                    }
                }else if(!type){
                    for(let i = (len-1);i >= 0; i--){
                        let char = str.charAt(i);
                        if(includes(operators,char)){
                            //从末尾查找最后一个
                            if(report){
                                if(char == str.charAt(i-1)){
                                    index = i;
                                    break ;
                                }
                            }else{
                                index = i;
                                break ;
                            }
                        }
                    }
                }
                return index;
            }
        },
        loadCanditionList(){
            let formKeys = '';
            let nodeSet = [];
            const bpmnModeler = this.bpmnModeler();
            const canvas = bpmnModeler.get('canvas');
            let children = canvas.getRootElement().children;
            let shapes = filter(children,function(c){
                return !(c.type == 'label');
            });

            //创建有向图
            let ngGraph = new AdjacencyMatrixGraph();
            //将流程图中所有元素当作有向图的顶点加入
            forEach(shapes,function(item){
                ngGraph.setNode(item.id);
            });
            //根据流程图的添加图的弧
            forEach(shapes,function(item){
                //如果是连线，没有outgoing，只有target
                if(is(item,'bpmn:SequenceFlow')){
                    ngGraph.setEdge(item.id,item.target.id);
                }else{
                    forEach(item.outgoing,function(outgoing){
                        ngGraph.setEdge(item.id,outgoing.id);
                    });
                }
            });
            //获取流程图中的所有可能经历过的节点
            let allPreNodes = ngGraph.allPredecessors(this.element.id);
            // 这里我设置为空，需要自己加
            // this.conditionList = [];
        },
        //设置组件的值
        initSubComponent(variableInfo){
            variableInfo  = variableInfo || this.getVariableInfo();
            if(variableInfo){
                if(variableInfo.type == 'result'){
                    this.conditionalOpts = [];
                    this.conditionalOpts = OperatorLessOptions;
                    this.form.tmp.componentType = 'select';
                    this.form.tmp.conditionalValData = this.dataList;
                }
                if (variableInfo.type == "number") {
                    $scope.dataStatus.INPUT = true;
                    return;
                }

                //如果是select型则要获取select列表数据
                if (variableInfo.type == 'select') {
                    // TODO
                    return;
                }
                //如果是日期控件
                if (variableInfo.type == 'date') {
                    // TODO
                    return;
                }

                //如果是tree
                if (variableInfo.type == 'inputtree') {
                    // TODO
                    return;
                }

                //如果是lookup
                if (variableInfo.type == 'lookup') {
                   // TODO
                    return;
                }
            }
        },
        translateAllConditions(){
            let conditions = this.table.conditions;
            let conditionList = this.conditionList;
            let dataList = this.dataList;
            forEach(conditions,function(condition){

                let conditionInfo = find(conditionList,{VALUE:condition.variable});
                if(conditionInfo){
                    //翻译变量名称
                    condition.variableLabel = conditionInfo.TEXT;
                    //如果条件类型为结果类型的
                    // if(conditionInfo.type = 'result'){
                    //     //翻译条件值
                        // let resultInfo = find(dataList,{VALUE:condition.conditionalVal});
                        // condition.conditionalValLabel = resultInfo.TEXT;
                    // }
                    let resultInfo = find(dataList,{VALUE:condition.conditionalVal});
                    if(resultInfo){
                        condition.conditionalValLabel = resultInfo.TEXT;
                    }else{
                        condition.conditionalValLabel = condition.conditionalVal;
                    }

                }
                let optInfo = find(OperatorAllOptions,{VALUE:condition.conditionalOpt});
                if(optInfo){
                    //翻译操作符
                    condition.conditionalOptLabel = optInfo.TEXT;
                }
                let logicInfo = find(LogicOptions,{VALUE:condition.logic});
                if(logicInfo){
                    //翻译逻辑符
                    condition.logicLabel = logicInfo.TEXT;
                }else{
                    condition.logicLabel = '无';
                }
            });
        },
        getVariableInfo(variableVal){
            if(variableVal === undefined){
                variableVal = this.form.variable;
            }
            return find(this.conditionList,{VALUE:variableVal});
        }
    },
    watch:{
        element:{
            deep:true,
            immediate: true,
            handler(element,oldVal){
                this.name = element.businessObject.name;
                let exp = ''
                try {
                    exp = element.businessObject.conditionExpression.body;
                }catch(error) {
                    exp = ''
                }

                
                // console.log('exp', exp)
                // console.log(element)
                if(exp){
                    if(exp === '${isPass == true}'){
                        this.defaultflow = true;
                    }else if(exp === '${isPass == false}'){
                        this.defaultflow = false;
                    }else{
                        this.defaultflow = ''
                    } 
                }
                //显示条件配置选项
                this.needConditiona = true;
                // this.defaultflow = false;
                //获取source节点
                let sourceBo = bpmnHelper.getBo(element.source);
                if(!sourceBo){
                    return;
                }
                //获取source上的默认连线
                // let defalutSequence = element.businessObject.get('defaultflow');
                // if(defalutSequence){
                //     this.defaultflow = true;
                // }
                //加载条件
                this.loadCondition();
            }
        },
        name: {
            handler(newVal, oldVal) {
                this.modeling.updateProperties(this.element, {
                    'name': newVal
                })
            }
        },
        /***
        condition: {
            handler(newVal, oldVal) {
                this.modeling.updateProperties(this.element, {
                    'condition': newVal
                })
            }
        },
        ***/
        // defaultflow(newVal,oldVal){
        //     if(!this.element.source){
        //         return;
        //     }

        //     this.modeling.updateProperties(this.element, {
        //         'defaultflow': newVal
        //     })
        // },
        //监控变量的值
        'form.variable':{
            immediate: true,
            handler:function(newVal,oldVal){
                if(newVal === ''){
                    return;
                }
                let variableInfo = this.getVariableInfo(newVal);
                //初始化组组件的值
                this.initSubComponent(variableInfo);
                let currentRow = this.table.selectedRow;
                currentRow.variable = newVal;
                currentRow.variableLabel = newVal;
                let index = findIndex(this.table.conditions,{id:currentRow.id})
                this.$set(this.table.conditions,index,currentRow);
                // if(variableInfo){
                //     let currentRow = this.table.selectedRow;
                //     let index = findIndex(this.table.conditions,{id:currentRow.id});
                //     currentRow.variable = newVal,
                //     currentRow.variableLabel = variableInfo;
                //     this.$set(this.table.conditions,index,currentRow);
                // }

            }
        },
        'form.conditionalOpt':function(newVal,oldVal){
            // let variableInfo = this.getVariableInfo();
            let currentRow =this.table.selectedRow;
            if(currentRow){
                currentRow.conditionalOpt = newVal;
                currentRow.conditionalOptLabel = newVal;
                let index = findIndex(this.table.conditions,{id:currentRow.id})
                this.$set(this.table.conditions,index,currentRow);
                // if(variableInfo){
                //     let index = findIndex(this.table.conditions,{id:currentRow.id});
                //     if(variableInfo.type == 'result'){
                //         currentRow.conditionalOpt = newVal;
                //         let opt = find(OperatorLessOptions,{VALUE:newVal})
                //         if(opt){
                //             currentRow.conditionalOptLabel = opt.TEXT;
                //         }
                //         this.$set(this.table.conditions,index,currentRow);
                //     }
                // }
            }


        },
        'form.conditionalVal':function(newVal,oldVal){
            if(newVal !== oldVal){
                // let variableInfo = this.getVariableInfo();
                let currentRow = this.table.selectedRow;
                if(currentRow){
                    currentRow.conditionalVal = newVal;
                    currentRow.conditionalValLabel = newVal;
                    let index = findIndex(this.table.conditions,{id:currentRow.id})
                    this.$set(this.table.conditions,index,currentRow);
                    // if(variableInfo){
                    //     let index = findIndex(this.table.conditions,{id:currentRow.id});
                    //     if(variableInfo.type == 'result'){
                    //         currentRow.conditionalVal = newVal;
                    //         let result = find(this.dataList,{VALUE:newVal});
                    //         if(result){
                    //             currentRow.conditionalValLabel = result.TEXT;
                    //         }
                    //         this.$set(this.table.conditions,index,currentRow);
                    //     }
                    // }
                }

            }
        },
        'form.logic':{
            immediate: true,
            handler:function(newVal,oldVal){
                let currentRow = this.table.selectedRow;
                if(currentRow){
                    let index = findIndex(this.table.conditions,{id:currentRow.id});
                    if(newVal !== oldVal){
                        currentRow.logic = newVal;
                        if(newVal == ''){
                            currentRow.logicLabel = '无';
                        }else{
                            let logicOpt = find(LogicOptions,{VALUE:newVal});
                            if(logicOpt){
                                currentRow.logicLabel = logicOpt.TEXT;
                            }
                        }
                        this.$set(this.table.conditions,index,currentRow);
                    }

                }
            }
        },
        'table.selectedRow':{
            deep:true,
            immediate: true,
            handler:function(newVal){
                if(newVal !== undefined){
                    this.formShow = true;
                    this.form.variable = newVal.variable;
                    let variableInfo = this.getVariableInfo();
                    this.initSubComponent(variableInfo);
                    this.form.conditionalOpt = newVal.conditionalOpt;
                    this.form.conditionalVal = newVal.conditionalVal;
                    this.form.logic = newVal.logic;
                    this.form.tmp.variableInfo = undefined;
                }else{
                    this.formShow = false;
                }
             }
        },
        'table.conditions':{
            immediate: true,
            handler:function(conditions){
                /***
                if(conditions === undefined || conditions.length == 0){
                     this.condition = '未配置任何条件';
                }else{
                    this.condition = '已配置'+conditions.length+'条件';
                }
                ***/
            }
        },




    }
}
//只有网关和活动才需要配置条件
const CONDITIONAL_SOURCES = [
  'bpmn:Activity',
  'bpmn:ExclusiveGateway',
  'bpmn:InclusiveGateway',
  'bpmn:ComplexGateway'
];

function isConditionalSource(element) {
  return isAny(element, CONDITIONAL_SOURCES);
}

//判断是否需要条件配置
function idNeedCondition(element,bo){
    if(!bo){
        return false;
    }
    let conditionalEventDefinition = eventDefinitionHelper.getConditionalEventDefinition(element);
    if (!(is(element, 'bpmn:SequenceFlow') && isConditionalSource(element.source))
        && !conditionalEventDefinition) {
        return false;
    }
    return true;
}
//校验表达式的正确性
function validateConditions(conditions){
    let flag = true;
    forEach(conditions,function(condition,index){
            index = index+1;
            if(isBlank(condition.variable)){
                console.error('第'+index+'个条件,变量不能为空');
                flag  = false;
                return;
            };
            if(isBlank(condition.conditionalOpt)){
                console.error('第'+index+'个条件,操作符不能为空');
                flag  = false;
                return;
            };
            if(isBlank(condition.conditionalVal)){
                console.error('第'+index+'个条件,变量值不能为空');
                flag  = false;
                return;
            };
            if(index < conditions.length){
                if(isBlank(condition.logic)){
                    console.error('配置多个条件时，须配置逻辑,第'+index+'个条件逻辑未配置');
                    flag  = false;
                    return  ;
                };
            }
    });
    return flag;
}

</script>
<style>

</style>
